import axios from "axios";
import sendLogs from "./logger";
import { getUserDetails } from "./functions";

export const createApi = ({ baseURL, utilsURL, utilsToken, platformAgentsToken, ASK_URL, ASK_URL_TOKEN }) => {
  const user = getUserDetails();

  const api = axios.create({
    baseURL,
    headers: {
      "Content-Type": "application/json",
    },
  });

  const APP_NAME = "AIWriter";

  // Helper to get formatted response time
  const getFormattedResponseTime = (startTime) => {
    const responseTime = startTime ? new Date() - startTime : 0;
    return responseTime < 1000 ? `${responseTime} ms` : `${(responseTime / 1000).toFixed(2)} sec`;
  };

  // Helper to extract formatted URL for logging
  const getFormattedUrl = (url) => {
    const match = url.match(/v1\/([^\/]+\/[^\/]+)\//);
    return match ? `/${match[1]}/` : null;
  };

  // Request Interceptor
  api.interceptors.request.use(
    (config) => {
      if (utilsURL && config.url.includes(utilsURL)) {
        config.headers.Authorization = `Bearer ${utilsToken}`;
      } else if (config.url.includes(ASK_URL)) {
        config.headers.Authorization = `Bearer ${ASK_URL_TOKEN}`;
      } else {
        config.headers.Authorization = `Bearer ${platformAgentsToken}`;
      }

      config.metadata = { startTime: new Date() };
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Response Interceptor
  api.interceptors.response.use(
    (response) => {
      const { metadata } = response.config;
      const formattedResponseTime = getFormattedResponseTime(metadata.startTime);
      const logUrl = getFormattedUrl(response.config?.url);
      const message = `Response: [${logUrl}] [${response.status}]`;

      sendLogs(
        "info",
        APP_NAME,
        user?.user_id || "N/A",
        message,
        formattedResponseTime
      );
      return response;
    },
    (error) => {
      const { config } = error;
      const metadata = config?.metadata || {};
      const formattedResponseTime = getFormattedResponseTime(metadata.startTime);
      const logUrl = getFormattedUrl(config?.url);
      const status = error.response?.status || "NO_RESPONSE";
      const errorMessage = error?.response?.data?.message || error?.message;
      const message = `Response Error: [${logUrl}] [${status}] - ${errorMessage}`;

      sendLogs("error", APP_NAME, user?.user_id || "N/A", message, formattedResponseTime);
      return Promise.reject(error);
    }
  );

  return api;
};
